interface Props {
  file: { name: string, url: string } | null | undefined
  text?: string
}

export const FileLink = ({ file, text }: Props) => {
  if (file)
    return <a href={file.url} target="_blank" rel="noreferrer">{text ?? file.name}</a>;
  return null;
}